import { useState } from "react";
import CompletionPopup from '../completion-popup';
import { useCareerContext } from '../career-context';

export default function SpotTheDifference() {
    const [question, setQuestion] = useState(1);
    const [explanation, setExplanation] = useState("");
    const [score, setScore] = useState(0);
    const [flexDirection, setFlexDirection] = useState("row");
    const [gameStarted, setGameStarted] = useState(false);
    const [verdict, setVerdict] = useState("");

    const {
        isPopupOpen,
        setIsPopupOpen,
        handleError,
        handleNotification,
        startConfetti
    } = useCareerContext();

    const questionToExplanation = {
        1: "The title for the conversation is too thin. This makes it hard to read.",
        2: "The speech bubble should not take up extra space.",
        3: "The color of the font is too light. This makes it hard to read.",
        4: "The color of the last online status doesn't have enough contrast with the background.",
        5: "Rounded edges are preffered over sharp edges. This way your eyes can follow the path around the edge smoothly.",
        6: "Be consistent! Only some of the icons are filled here!",
        7: "The button doesn't have enough contrast with the text/background. This style would be useful to indicate if something is not supposed to be clicked, for example, if it is still loading.",
    }
    function handleClick(isCorrect) {
        // if question has already been answered, do nothing
        if (verdict) {
            return;
        }
        if (isCorrect) {
            setScore(score + 1);
            setVerdict("Correct!");
        } else {
            setVerdict("Wrong!");
            setExplanation(questionToExplanation[question]);
        }

    }

    function handleNext() {
        if (question === 7) {
            setIsPopupOpen(true);
            return;
        }
        setFlexDirection(Math.random() > 0.5 ? "row" : "row-reverse");
        setQuestion(question + 1);
        setVerdict("");
        setExplanation("");
    }

    

    return (
        <>
            {isPopupOpen && 
            <CompletionPopup title="Complete" message={`Your score: ${score}`} 
                hidePopup={()=>{
                    setQuestion(1);
                    setScore(0);
                    setGameStarted(false);
                    setVerdict("");
                    setExplanation("");
                    setIsPopupOpen(false);
                    }}/>}
            {!gameStarted ? 
            <div className="spot-the-difference" style={{height: "600px", display: "grid", placeContent: "center"}}>
                <h1>Spot the Difference</h1>
                <p>Choose the "correct" design</p>
                <button className="primary-btn" onClick={()=>setGameStarted(true)}>Play</button>
            </div> : 

            <div className='spot-the-difference col center' style={{height: "600px"}}>
                <h1>Spot the Difference</h1>
                <p>{score + " points"}</p>
                <div className='question' style={{display: "flex", flexDirection:flexDirection}}>
                    <img src={require("../../img/spot-the-difference/" + question + "-correct.png")} alt="Spot the difference" onClick={() => handleClick(true)} />
                    <img src={require("../../img/spot-the-difference/" + question + "-wrong.png")} alt="Spot the difference" onClick={() => handleClick(false)} />
                </div>
                <div style={{height: "200px"}}>
                    <div className='explanation center'>
                        <p>{verdict}</p>
                        <p style={{margin: "10px"}}>{explanation}</p>
                    {verdict && <button className="primary-btn" style={{width: "fit-content", margin: "auto"}} onClick={handleNext}>Next</button>}
                </div>
                </div>
            </div>}

        </>
    )
}